import React, { Component } from 'react';
import { HubHeader } from '../../organisms';
import { withLanguageContext } from '../../../utils/LanguageContext';

class HubHeaderView extends Component {

	state = {
		navItems: this.genNavItems(this.props.content.hubLandingPage.navigation.items),
	};

	/**
	 * @argument {Object[]} items
	 * @returns {Object[]}
	 */
	genNavItems (items) {
		return items.map(({ href, name }) => ({
			children: name,
			href,
		}));
	}

	render () {
		return (
			<HubHeader navItems={this.state.navItems} />
		);
	}

}

export default withLanguageContext(HubHeaderView);



// WEBPACK FOOTER //
// ./src/components/views/HubHeaderView/HubHeaderView.js